const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsClube = { name: 'Clube', pathName: null, action: 'clube' }

export default [
  {
    path: '/v3/clube',
    name: 'Clube',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    meta: {
      breadcrumbs: [breadcrumbsHome, breadcrumbsClube],
    },
    children: [
      {
        path: 'dashboard',
        name: 'clube-dashboard',
        component: () => import('@/modules/clube/dashboard/views/pages/Dashboard.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Dashboard',
              pathName: null,
            },
          ],
          title: 'Dashboard',
          requiredUserPermissions: ['clube/dashboard'],
        },
      },
      {
        path: 'performance-operacional',
        name: 'clube-performance-operacional',
        component: () => import('@/modules/clube/performance-operacional/views/pages/PerformanceOperacional.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Performance operacional',
              pathName: null,
            },
          ],
          title: 'Performance operacional',
          requiredUserPermissions: ['clube/performance_operacional'],
          requiredModules: ['operational_performance'],
          requiresPiiEmployeesAccess: true,
        },
      },
      {
        path: 'performance-operacional/detalhes-operador/:id',
        name: 'clube-detalhes-operador',
        component: () => import('@/modules/clube/performance-operacional/views/pages/DetalhesOperador.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Performance Operacional',
              pathName: '/v3/clube/performance-operacional',
            },
            {
              name: 'Detalhes Operador',
              pathName: null,
            },
          ],
          title: 'Detalhes Operador',
          requiredUserPermissions: ['clube/performance_operacional'],
          requiredModules: ['operational_performance'],
          requiresPiiEmployeesAccess: true,
        },
      },
    ],
  },
]
